module.exports = __webpack_public_path__ + "static/assets/00eae4b48844a30b2f6926525e0ccdea.png";